import { KeenSliderPlugin } from 'keen-slider/react';

const WHEEL_END_DELAY_MS = 50;

/**
 * Lets people flick through the slider with a horizontal wheel gesture
 * (trackpad two-finger swipe, or Shift+Scroll) by replaying wheel deltas
 * as keen-slider drag events.
 */
export const createWheelControlsPlugin = (): KeenSliderPlugin => (slider) => {
  let dragPosition: { x: number; y: number };
  let dragEndTimeout: ReturnType<typeof setTimeout>;
  let isWheelDragging = false;

  const dispatchDragEvent = (event: WheelEvent, name: string) => {
    dragPosition.x -= event.deltaX;
    dragPosition.y -= event.deltaY;

    slider.container.dispatchEvent(
      new CustomEvent(name, {
        detail: {
          x: dragPosition.x,
          y: dragPosition.y,
        },
      }),
    );
  };

  const startDragEvent = (event: WheelEvent) => {
    dragPosition = {
      x: event.pageX,
      y: event.pageY,
    };
    dispatchDragEvent(event, 'ksDragStart');
  };

  const processDragEvent = (event: WheelEvent) => {
    dispatchDragEvent(event, 'ksDrag');
  };

  const endDragEvent = (event: WheelEvent) => {
    dispatchDragEvent(event, 'ksDragEnd');
  };

  const onWheel = (event: WheelEvent) => {
    // Ignore vertical-only scrolls to avoid interfering with the page scroll
    if (!event.deltaX) return;

    event.preventDefault();

    if (!isWheelDragging) {
      startDragEvent(event);
      isWheelDragging = true;
    }

    processDragEvent(event);

    clearTimeout(dragEndTimeout);

    dragEndTimeout = setTimeout(() => {
      isWheelDragging = false;
      endDragEvent(event);
    }, WHEEL_END_DELAY_MS);
  };

  slider.on('created', () => {
    slider.container.addEventListener('wheel', onWheel, { passive: false });
  });
};
